export default "__VITE_ASSET__RyUHWuXU__"